<script setup lang="ts">
import { computed } from "vue"
import DashboardBadge from "./DashboardBadge.vue"

const props = withDefaults(
  defineProps<{
    label?: string
    tooltip?: string
    status: string
  }>(),
  {
    label: undefined,
    tooltip: ""
  }
)

const displayLabel = computed(() => (props.label ?? props.status.replaceAll("-", " ")).toUpperCase())

const tone = computed<"success" | "warning" | "danger" | "neutral">(() => {
  if (["active", "available", "connected", "healthy", "normal", "ready", "stable", "success"].includes(props.status)) {
    return "success"
  }

  if (
    [
      "disconnecting",
      "draining",
      "high",
      "medium",
      "probationary",
      "review",
      "stale",
      "warming",
      "warn",
      "warning"
    ].includes(props.status)
  ) {
    return "warning"
  }

  if (
    ["blocked", "danger", "error", "expired", "failed", "low", "offline", "paused", "rejected"].includes(props.status)
  ) {
    return "danger"
  }

  return "neutral"
})
</script>

<template>
  <DashboardBadge :label="displayLabel" :tone="tone" :tooltip="tooltip" />
</template>
